import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.js';
import { I18nProvider } from './context/I18nContext.js';
import { setupMockTelegramWebApp } from './telegram/mock.js';

import './telegram/types.js';
import './index.css';

// If in local dev environment and outside Telegram, setup mock WebApp (SET-18)
if (import.meta.env.DEV && !window.Telegram?.WebApp?.initData) {
  setupMockTelegramWebApp();
}

const userLang = window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <I18nProvider initialLocale={userLang}>
      <App />
    </I18nProvider>
  </React.StrictMode>
);
